import styled from 'styled-components';

export const FilterButtonContainer = styled.div`
	display: flex;
	align-items: center;
	font-size: 0.875rem;
	background-color: #257226;//var(--ion-color-secondary);
	color: #fff;
	border-radius: 50px;
	padding: 0 0.5rem;
	ion-select {
		padding: 0.3rem;
	}
`;

export const FilterByLabel = styled.div`
	padding: 0.1rem 0.5rem;
	border-right: 1px solid var(--ion-color-step-800);
	color: #ffffff;//var(--ion-color-step-500);
`;

